module.exports = __webpack_public_path__ + "assets/img/Mac.aaefcd1c.svg";